import { useSearch } from "./useSearch";

const fallbackCopy = (text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.select();
  let success = false;
  try {
    // execCommand("copy") no lanza excepciones — simplemente retorna false,
    success = document.execCommand("copy");
  } finally {
    document.body.removeChild(textArea);
  }
  if (!success) {
    throw new Error("execCommand('copy') falló.");
  }
};

const writeToClipboard = async (text) => {
  // Intenta usar Clipboard API async; si el objeto/método no existe o la
  // promesa se rechaza (iOS Safari, sin gesto de usuario, permiso denegado,
  // contexto no seguro sobre HTTP), cae al fallback con execCommand.
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }
  } catch (error) {
    console.error("Clipboard API falló, usando fallback:", error);
  }
  fallbackCopy(text);
};

export const useCopyText = (
  textToCopy = "",
  successMsg = "¡Información copiada al portapapeles!"
) => {
  const { setSnackbar } = useSearch();

  const copyToClipboard = async () => {
    try {
      await writeToClipboard(textToCopy);
      setSnackbar(successMsg, "success");
    } catch (error) {
      console.error(error);
      setSnackbar("Hubo un error al copiar la información al portapapeles.");
    }
  };

  return copyToClipboard;
};
